import TrustRateStars from '@assets/images/trust-rate-stars.svg';
import {
	TrustRatingBar,
	TrustRatingEvaluation,
	TrustRatingScore,
	TrustRatingText,
	TrustRatingUsers,
	TrustRatingWrapper,
} from './trustRating.styled';

interface Modifiers {
	marginBottom?: string;
}

interface TrustRatingProps {
	reviewLabel: string;
	reviewScore: string;
	reviewEvaluation: string;
	reviewCount: string;
	reviewImage: string;
	modifiers?: Modifiers;
}

const TrustRating: React.FC<TrustRatingProps> = ({
	reviewLabel,
	reviewScore,
	reviewEvaluation,
	reviewCount,
	reviewImage,
	modifiers,
}) => {
	return (
		<TrustRatingWrapper marginBottom={modifiers?.marginBottom}>
			<TrustRatingText>{reviewLabel}</TrustRatingText>
			<TrustRatingScore>{reviewScore}</TrustRatingScore>
			<TrustRatingBar>
				<img src={reviewImage ? reviewImage : TrustRateStars} alt="Rating" />
			</TrustRatingBar>
			<TrustRatingEvaluation>{reviewEvaluation}</TrustRatingEvaluation>
			<TrustRatingUsers>{reviewCount}</TrustRatingUsers>
		</TrustRatingWrapper>
	);
};

export default TrustRating;
